import { Box, Group, Text } from '@mantine/core';

const Logo = () => {
    return (
        <Group align={'center'}>
            {/*<img
                alt={'SmartCard Manager'}
                src={'/assets/img/btchoster_logo.png'}
                style={{
                    height: '15px',
                }}
            /> */}
            <Text span>
                Reach
                <Text
                    fw={'bold'}
                    mx={0}
                    span>
                    SMS
                </Text>
            </Text>
        </Group>
    );
};
export default Logo;
